import { prevArrow, nextArrow, options } from "@/global/slick-options";

const sliders = document.querySelectorAll( '.icons-slider' );

sliders.forEach( slider => {
    jQuery( slider ).slick( {
        ...options,
        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 639,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    } );

} );
